enum PacingStrategyEnum {
  AUDIENCE = 'audience',
  LINEAR = 'linear',
  SQRT = 'sqrt',
  FASTEST = 'fastest',
  AHEAD = 'ahead',
}
export default PacingStrategyEnum;
